var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClockGreen = function SvgClockGreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 21,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#198038",
    fillRule: "evenodd",
    clipPath: "url(#clock-green_svg__a)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.65 12.951h-.662a.74.74 0 0 1-.738-.738.74.74 0 0 1 .738-.738h.96a.74.74 0 0 1 .738.738.74.74 0 0 1-.738.738zM14.242 5.23c-.67 0-1.312.12-1.906.339H6.834a.74.74 0 0 0-.738.738.74.74 0 0 0 .738.738h1.42a.74.74 0 0 1 .739.738.74.74 0 0 1-.738.738H3.533a.74.74 0 0 0-.738.738.74.74 0 0 0 .738.739H6.7a.74.74 0 0 1 .738.738.74.74 0 0 1-.738.738h-.545a.74.74 0 0 0-.738.738.74.74 0 0 0 .738.738h2.65a.74.74 0 0 1 .739.738.74.74 0 0 1-.738.738H7.482a.74.74 0 0 0-.737.738.74.74 0 0 0 .737.739h4.855A5.507 5.507 0 1 0 14.243 5.23M12.969 9.46a.39.39 0 0 1 .554 0l.703.703 1.765-2.003a.393.393 0 0 1 .553-.035.393.393 0 0 1 .035.553l-1.903 2.158a.445.445 0 0 1-.858.028l-.85-.85a.393.393 0 0 1 0-.554m-3.094.961a4.38 4.38 0 0 1 4.054-4.053v.888h.628V6.37a4.38 4.38 0 0 1 4.054 4.053h-.889v.629h.89a4.38 4.38 0 0 1-4.054 4.054v-.889h-.63v.889a4.38 4.38 0 0 1-4.053-4.054h.889v-.629z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.226 10.164-.703-.703a.392.392 0 0 0-.554.554l.85.85a.445.445 0 0 0 .425.316c.2 0 .386-.146.432-.343l1.904-2.159a.393.393 0 0 0-.035-.553.393.393 0 0 0-.553.035z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clock-green_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2.25 5.23h17.5v11.014H2.25z"
  })))));
};
export default SvgClockGreen;